export default {
  users(state) {
    return JSON.parse(JSON.stringify(state.users));
  },
  usersCount(state) {
    return state.usersCount;
  },
  pageLimit(state) {
    return state.pageLimit;
  },
  userInfo(state) {
    if (!state.userInfo) {
      state.userInfo = {};
    }
    return JSON.parse(JSON.stringify(state.userInfo));
  },
  domainSkills(state) {
    return JSON.parse(JSON.stringify(state.domainSkills));
  },
  dialoutNum(state) {
    return state.dialoutNum;
  },
  userLoginStatus(state) {
    return JSON.parse(JSON.stringify(state.userLoginStatus));
  },
  domainRanges(state) {
    return JSON.parse(JSON.stringify(state.domainRanges));
  },
  domainUsers(state) {
    return JSON.parse(JSON.stringify(state.domainUsers));
  },
  skillInfo(state) {
    return JSON.parse(JSON.stringify(state.skillInfo));
  },
  schedules(state) {
    return JSON.parse(JSON.stringify(state.schedules));
  },
  waitClasses(state) {
    return JSON.parse(JSON.stringify(state.waitClasses));
  },
  welcomeMessage(state) {
    return JSON.parse(JSON.stringify(state.welcomeMessage));
  },

  allDomains(state) {
    return JSON.parse(JSON.stringify(state.allDomains));
  },
  domainInfo(state) {
    return JSON.parse(JSON.stringify(state.domainInfo));
  },
  domainsNames(state) {
    return JSON.parse(JSON.stringify(state.domainsNames));
  },
  domainsShortCodes(state) {
    return JSON.parse(JSON.stringify(state.domainsShortCodes));
  },
  domainsRanges(state) {
    return JSON.parse(JSON.stringify(state.domainsRanges));
  },
  domainsNotDefaultPermissions(state) {
    return JSON.parse(JSON.stringify(state.domainsNotDefaultPermissions));
  },
  domainDefaultUserPermissions(state) {
    return JSON.parse(JSON.stringify(state.domainDefaultUserPermissions));
  },
  domainDefaultPhoneInfo(state) {
    return JSON.parse(JSON.stringify(state.domainDefaultPhoneInfo));
  },
  domainsSkills(state) {
    return JSON.parse(JSON.stringify(state.domainsSkills));
  },
  domainUsernames(state) {
    return JSON.parse(JSON.stringify(state.domainUsernames));
  },
  callReasons(state) {
    return JSON.parse(JSON.stringify(state.callReasons));
  },
  ivrRating(state) {
    return JSON.parse(JSON.stringify(state.ivrRating));
  },
  omniRating(state) {
    return JSON.parse(JSON.stringify(state.omniRating));
  },
  kpis(state) {
    return JSON.parse(JSON.stringify(state.kpis));
  },
  csatReport(state) {
    return JSON.parse(JSON.stringify(state.csatReport));
  },
  csatQuestions(state) {
    const questions = JSON.parse(JSON.stringify(state.csatQuestions));
    return questions.sort((a, b) => {
      // quest_order 0 means disabled, push to end
      if (a.quest_order === 0 && b.quest_order === 0) return 0;
      if (a.quest_order === 0) return 1;
      if (b.quest_order === 0) return -1;
      return a.quest_order - b.quest_order;
    });
  },
  statusReasons(state) {
    return JSON.parse(JSON.stringify(state.statusReasons));
  },
  userLimits(state) {
    return JSON.parse(JSON.stringify(state.userLimits));
  },
};
